var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRuby = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 23",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9b1010",
  d: "m23 5.111-1.278 16.61L5.112 23z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#b71c1c",
  d: "m14.055 14.056 7.667 7.666L23 5.112z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#c62828",
  d: "M21.72 1.28C18.81-1.63 11.873.588 6.231 6.233.587 11.874-1.63 18.81 1.28 21.719s9.845.694 15.487-4.95C22.413 11.125 24.63 4.19 21.72 1.28"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#e53935",
  d: "m2.556 7.028 4.472-4.472L12.138 0l3.834 2.556-1.916 5.75-5.75 5.11-5.75 1.917L0 11.5z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff5252",
  d: "M15.972 2.556 12.139 0h7.027zM23 5.75l-7.028-3.194-1.917 5.75zM8.305 13.417l8.455 3.344-2.706-8.455zm-5.75 1.916L5.11 23l3.195-9.583zM0 11.5v7.028l2.556-3.195z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRuby);
export default ForwardRef;